import InAppMessage from "./in-app-message.js";
import { DOMUtils as ue } from "../../util/dom-utils.js";
export default class SlideUpMessage extends InAppMessage {
  constructor(
    e,
    t,
    s,
    o,
    i,
    r,
    n,
    d,
    a,
    u,
    p,
    m,
    c,
    l,
    v,
    x,
    f,
    h,
    g,
    I,
    M,
    b,
  ) {
    (x = x || InAppMessage.th.Mh),
      (v = v || InAppMessage.th.Rh),
      super(
        e,
        (t = t || InAppMessage.TextAlignment.START),
        s,
        o,
        i,
        r,
        n,
        d,
        a,
        u,
        p,
        m,
        void 0,
        c,
        l,
        v,
        x,
        f,
        h,
        g,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        I,
        M,
        b,
      ),
      (this.$o = InAppMessage.TextAlignment.START);
  }
  vo() {
    return !1;
  }
  zo() {
    const e = document.createElement("span");
    return e.appendChild(document.createTextNode(this.message || "")), e;
  }
  Ah(e) {
    const t = e.getElementsByClassName("ab-in-app-message")[0];
    ue.Ho(t, !0, !0) ||
      (this.slideFrom === InAppMessage.SlideFrom.TOP
        ? (t.style.top = "0px")
        : (t.style.bottom = "0px")),
      super.Ah(e);
  }
  bt() {
    return super.bt(SlideUpMessage.cs);
  }
  static Qr(e) {
    return new SlideUpMessage(
      e[InAppMessage.es.ra],
      e[InAppMessage.es.sa],
      e[InAppMessage.es.Sh],
      e[InAppMessage.es.qs],
      e[InAppMessage.es.ta],
      e[InAppMessage.es.ia],
      e[InAppMessage.es.URI],
      e[InAppMessage.es.oa],
      e[InAppMessage.es.pa],
      e[InAppMessage.es.ma],
      e[InAppMessage.es.na],
      e[InAppMessage.es.ls],
      e[InAppMessage.es.ca],
      e[InAppMessage.es.fa],
      e[InAppMessage.es.da],
      e[InAppMessage.es.la],
      e[InAppMessage.es.ga],
      e[InAppMessage.es.ja],
      e[InAppMessage.es.xa],
      e[InAppMessage.es.ka],
      e[InAppMessage.es.CSS],
      e[InAppMessage.es.qa],
    );
  }
}
SlideUpMessage.cs = InAppMessage.bo.Wr;
